<template>
    <div :class="resetForm ? 'visible' : 'invisible'">
        <div :class="ResetBox ? 'visible' : 'invisible'">
            <div class="trip">
                {{ $t("newPassword.heading") }}
            </div>

            <div class="d-flex justify-center align-center" style="height: 54vh;">
                <v-form v-model="valid" ref="form" @submit.prevent="resetSubmit">
                    <div class="pre-card">
                        <v-card style="width: 550px;padding: 30px;">
                            <div v-if="hideFields">
                                <div>
                                    <v-text-field v-model="resetDetails.newPassword" :rules="userPass" :label="this.$t('newPassword.password')"
                                        :placeholder="this.$t('newPassword.enterPass')" variant="underlined" required
                                        :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
                                        :type="visible ? 'text' : 'password'" @click:append-inner="visible = !visible"
                                        style="height:60px;font-size: 15px !important"></v-text-field>
                                </div>

                                <div>
                                    <v-text-field v-model="resetDetails.conPassword" :rules="userConfirmPass"
                                        :label="this.$t('newPassword.confirmPassword')" :placeholder="this.$t('newPassword.enterCon')" variant="underlined"
                                        required :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
                                        :type="visible ? 'text' : 'password'" @click:append-inner="visible = !visible"
                                        style="height:60px;font-size: 15px !important"></v-text-field>
                                </div>
                            </div>

                            <div class="d-flex mt-3">
                                <div class="col-9 d-flex justify-end">
                                    <v-btn style="background-color:#ff6b0a; color:white" width="60%" :disabled="btnDisabled"
                                        type="submit" v-if="resetBtn">{{ $t("newPassword.resetBtn") }}</v-btn>
                                </div>
                                <div class="col-3 ps-1 d-flex ps-4">
                                    <v-progress-circular v-if="loadSpinner" :width="3" style="color:navy"
                                        indeterminate></v-progress-circular>
                                </div>
                            </div>
                        </v-card>
                    </div>
                </v-form>
            </div>
        </div>
    </div>


    <div v-if="overlay">
        <dataloader></dataloader>
    </div>


    <v-dialog v-model="updateDialog" persistent>
        <div class="d-flex justify-center">
            <v-card class="p-4">
                <div v-if="resMessage">
                    <h6 class="text-center text-success">{{ resMessage }}...</h6>
                </div>
                <div class="d-flex justify-space-evenly mt-3">
                    <!-- <v-btn @click="dialog3 = false" color="#ff6b0a">Try Again</v-btn> -->

                    <v-btn to="/" color="#ff6b0a">Return to Home</v-btn>
                </div>
            </v-card>
        </div>
    </v-dialog>


    <v-dialog v-model="dialogBox">
        <div class="d-flex justify-center">
            <v-card class="p-4">
                <h3 class="text-center">OOPS!</h3>
                <h5>
                    Your request cannot be processed at this moment.
                </h5>
                <h6>Please contact customer support.</h6>
                <div class="d-flex justify-space-evenly mt-3">
                    <!-- <v-btn @click="dialog3 = false" color="#ff6b0a">Try Again</v-btn> -->

                    <v-btn to="/" color="#ff6b0a">Return to Home</v-btn>
                </div>
            </v-card>
        </div>
    </v-dialog>
</template>


<script>
import axios from 'axios'

import { getConfigDataFromLocalStorage } from '@/localStorageData/localStorageUtil.js';

import dataloader from "@/components/dataLoder.vue";

// import axios from 'axios'

export default {

    components: {
        dataloader
    },

    data() {
        return {
            ResetBox: false,
            terms: false,
            visible: false,
            loadSpinner: false,
            btnDisabled: false,
            resetBtn: true,
            resetForm: true,

            updateDialog: false,

            hideFields: false,
            resMessage: "",

            overlay: true,
            dialogBox: false,

            loginshow: true,
            resetshow: false,


            resetDetails: {
                newPassword: "",
                conPassword: "",
            },

            eMail: [
                v => !!v || 'Please enter your email',
                v => /.+@.+/.test(v) || 'E-mail must be valid',
            ],


            userPass: [
                v => !!v || 'Please enter your Password',
                v => !/\s/.test(v) || 'Password cannot contain spaces',
                // v => v === this.resetDetails.conPassword || 'Passwords do not match',
                // v => /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])(?!.*\s).{8,}$/.test(v) || 'Password must contain at least 8 or more characters without spaces'
            ],
            userConfirmPass: [
                () => !!this.resetDetails.newPassword || 'Please enter your New Password first',
                v => !!v || 'Please enter your Confirm Password',
                v => v === this.resetDetails.newPassword || 'Passwords do not match'
            ],


            getId: "",
            getMail: "",

            userRequest: {
                "request_type": "reset_password",
                "email": "irwogms@gmail.com",
                "enkey": "qt3cU5nWjV2OPeQBEYkwD4adr8oy9I",
                "user_id": "736473",
                "portal_id": "port8787"
            },

            resetRequest: {
                "request_type": "change_password",
                "new_password": "ekfjhury84r8",
                "confirm_password": "ekfjhury84r8",
                "email": "irwogms@gail.com",
                "user_id": "736473",
                "portal_id": "port8787"
            },

            checkPassword: "",
            updatePassword: "",
        }
    },
    methods: {


        checkingReset() {
            this.userRequest.enkey = this.getId
            this.userRequest.email = this.getMail

            console.log(this.userRequest, 'vvvvaaaallll')

            axios.post(this.checkPassword, this.userRequest, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })

                .then(response => {
                    console.log(response, "dfsdvdff")
                    if (response.data.reset_password_response == 'success') {
                        this.ResetBox = true
                        this.overlay = false
                        this.hideFields = true
                    }
                    else if (response.data.reset_password_response == 'fail') {
                        this.ResetBox = false
                        // this.resMessage = response.data.msg

                        setTimeout(() => {
                            this.dialogBox = true
                        }, 20000)
                        // this.$router.push('/')
                    }
                    else {
                        this.ResetBox = false
                        setTimeout(() => {
                            this.dialogBox = true
                        }, 20000)
                        // this.$router.push('/')
                    }
                })
                .catch(errors => {
                    console.log(errors, "eeeerrrrroooossssss......")
                    this.ResetBox = false
                    this.$router.push('/')
                })
        },


        resetSubmit() {
            if (this.valid) {

                this.loadSpinner = true
                this.btnDisabled = true

                this.resetRequest.email = this.getMail
                this.resetRequest.new_password = this.resetDetails.newPassword
                this.resetRequest.confirm_password = this.resetDetails.conPassword

                console.log(this.resetRequest, 'resetRequest:....')

                axios.post(this.updatePassword, this.resetRequest, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })

                    .then(response => {
                        console.log(response, "response for reset pass.....")
                        if (response) {
                            this.loadSpinner = false
                            this.hideFields = false
                            this.resetBtn = false
                            this.resMessage = response.data.msg
                            this.updateDialog = true
                            this.resetForm = false
                            this.ResetBox = false
                        }
                    })
                    .catch(errors => {
                        console.log(errors, "dfsdvdff")
                    })
            }
        },

        getConfig() {
            // let portalLocal = localStorage.getItem("portalData")
            // let getConfigData1 = JSON.parse(portalLocal)
            const getConfigData1 = getConfigDataFromLocalStorage();
            if (getConfigData1) {
                this.checkPassword = getConfigData1.payload.portal_configuration.API_endpoints.check_password
                this.updatePassword = getConfigData1.payload.portal_configuration.API_endpoints.update_password
            }
        },
    },

    created() {
        this.getConfig();

        this.getId = this.$route.query.enkey
        this.getMail = this.$route.query.email
        console.log(this.getId, this.getMail, 'gggggIIiiddi')

        this.checkingReset()
    }




}
</script>



<style scoped>
.trip {
    justify-content: center;
    display: flex;
    background-color: #f3d8cf;
    padding: 30px;
    font-size: 25px;
    font-weight: 600;
}

.pre-card {
    display: flex;
    justify-content: center;
    border-radius: 15px;
}

/* Login Page */

.main-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

/* .form-btn {
  padding-left: 40px;
  color: white;
} */

.btn-box {
    background-color: transparent;
    margin: 5px;
    padding: 2px;
    box-shadow: none;
}

.btn-active {
    background-color: blueviolet;
    color: white;
}

.v-checkbox .v-input__details {
    display: none;
}

>>>.v-label--clickable {
    cursor: pointer;
    font-size: 12px;
}

>>>.v-input__details {
    display: block !important;
}

.forgotStyle {
    font-weight: 500;
    font-size: 13px;
    letter-spacing: 1px;
    color: #0D6EFD;
    text-decoration: underline;
    cursor: pointer;
}

/* Login Page End */



@media only screen and (max-width: 992px) {

    .form-btn {
        padding: 10px 0px 0px 0px !important;
        /* color: white; */
    }

    .btn-box,
    .pipe {
        color: blueviolet !important;
    }

    .btn-active {
        background-color: blueviolet;
        color: white !important;
    }
}
</style>
